document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-sticky-header]');
  if (header) {
    const syncHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
  }

  document.querySelectorAll('[data-accordion]').forEach((item) => {
    const button = item.querySelector('button');
    const panel = item.querySelector('[data-accordion-panel]');
    if (!button || !panel) return;
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
  });

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    if (!input) return;
    control.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', () => {
        const step = Number(input.step) || 1;
        const current = Number(input.value) || 1;
        const min = Number(input.min) || 1;
        input.value = String(button.dataset.action === 'increase' ? current + step : Math.max(min, current - step));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    const select = productForm.querySelector('[data-variant-select]');
    const idInput = productForm.querySelector('input[name="id"]');
    const button = productForm.querySelector('[type="submit"]');
    if (select && idInput) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        idInput.value = option.value;
        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
        }
      });
    }
  }

  document.querySelectorAll('[data-sales-toast]').forEach((toast) => {
    const items = Array.from(toast.querySelectorAll('[data-sales-toast-item]'));
    const close = toast.querySelector('.sales-toast__close');
    if (!items.length) return;

    const delay = Number(toast.dataset.delay) || 6000;
    const duration = Number(toast.dataset.duration) || 6000;
    let index = 0;
    let timer;
    let closed = false;

    const hide = () => toast.classList.remove('is-visible');
    const showNext = () => {
      if (closed) return;
      items.forEach((item) => item.classList.remove('is-current'));
      items[index].classList.add('is-current');
      toast.classList.add('is-visible');
      index = (index + 1) % items.length;
      timer = window.setTimeout(() => {
        hide();
        timer = window.setTimeout(showNext, delay);
      }, duration);
    };

    timer = window.setTimeout(showNext, delay);
    close?.addEventListener('click', () => {
      closed = true;
      window.clearTimeout(timer);
      hide();
    });
  });
});
